import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export const wizardState = {
    courses: null,
    selected: {
        course: null,
        paymentmethod: null,
        user: null,
        dues: null
    },
    trans: null,
    locale: null,
    registration: {}


};

export const wizardGetters = {
    ...getters
};

export const wizardMutations = {
    ...mutations
};
export const wizardActions = {
    ...actions
};
